import store from "../../../store";
import bond_export from './bond_export.vue';

window.bond_export =  new Vue({
    store,
    el: 'div#bond_export',

    name : "bond_export",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        bond_export,
    }
});
